import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App.tsx';
import './styles/styles.scss';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
